export default "__VITE_ASSET__Dog8wNQq__"